import { Caption } from "@bcc-ui/ui-components";
import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";

import style from "./ai-disclaimer.scss";

interface Props {
    whiteColor?: boolean;
}

const AIDisclaimer = (props: Props) => {
    const { t } = useTranslation();

    return (
        <Caption greyTextStyle className={classNames(style.disclaimer, { [style.whiteText]: props.whiteColor })}>
            {t("AiAgent.disclaimer")}
        </Caption>
    );
};

export default AIDisclaimer;
